import type { ImageFileTypes } from '@library/types/polls';

export interface FileUploaderHeaderProps {
  className?: string;
  fileType?: 'csv' | ImageFileTypes;
}
export const FileUploaderHeader = ({
  className = '',
  fileType = 'csv'
}: FileUploaderHeaderProps) => {
  return (
    <div
      className={className || 'flex h-full items-center justify-center px-5'}
    >
      <h3 className="text-lg font-bold leading-5">
        Upload {fileType.toUpperCase()}
      </h3>
    </div>
  );
};
